// extracted by mini-css-extract-plugin
module.exports = {"page":"_5D1fQwFg","card":"_5D3Y9JMv"};